export default __webpack_public_path__ + "static/media/whatsapp.69d50b83.svg";